import { RealisationHourtype } from '../app/classes/realisation';

export const defaultHourtypeLabels: Record<RealisationHourtype, string> = {
    [RealisationHourtype.additional_parental]: 'Aanv. geb verl. + ouderschapsv',
    [RealisationHourtype.bank_holiday]: 'Feestdag',
    [RealisationHourtype.day_off]: 'Roostervrij',
    [RealisationHourtype.driving_back]: 'Transporttijd',
    [RealisationHourtype.driving_to]: 'Transporttijd',
    [RealisationHourtype.education]: 'Scholing',
    [RealisationHourtype.frost]: 'Spaaruren',
    [RealisationHourtype.illness]: 'Ziek',
    [RealisationHourtype.loading_unloading]: 'Laden/lossen',
    [RealisationHourtype.loading_unloading_end]: 'Lossen/laden',
    [RealisationHourtype.not_available]: 'Niet beschikbaar',
    [RealisationHourtype.office]: 'Werken op zaak',
    [RealisationHourtype.paid_leave]: 'Doorbetaald verlof',
    [RealisationHourtype.rain]: 'Regen',
    [RealisationHourtype.repair_maintenance]: 'Reparatie/Onderhoud materieel',
    [RealisationHourtype.setting_out]: 'Uitzetten',
    [RealisationHourtype.short_absence]: 'Kort verzuim',
    [RealisationHourtype.sleep]: 'Slapen',
    [RealisationHourtype.special_leave]: 'Bijzonder verlof',
    [RealisationHourtype.time_for_time]: 'Tijd voor tijd',
    [RealisationHourtype.travel_back]: 'Reistijd',
    [RealisationHourtype.travel_to]: 'Reistijd',
    [RealisationHourtype.waiting]: 'Wachten',
    [RealisationHourtype.worktime]: 'Werktijd',
    [RealisationHourtype.zzp_leave]: 'ZZP niet beschikbaar',
};
